import cx from 'clsx';
import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { ReactComponent as ExpandRowIcon } from '@assets/svg/executive-summary/ic-expand-row.svg';

import { useCustomerInfoQuery } from '@services/useCustomerInfoQuery';

import { selectAppLocationSelectValue } from '@store/useAppStore';

import type { ICostSavingDetailsByMonth } from '../../model/costSavingDetails';
import ActionItemsByMonthTable from '../ActionItemsByMonthTable/ActionItemsByMonthTable';
import style from './style.module.scss';

interface IProps {
  row: ICostSavingDetailsByMonth;
}

const ExpandedRow: React.FC<IProps> = ({ row }) => {
  const { state } = useLocation();
  const { customerId } = useParams();
  const [isVisibleHiddenRow, setVisibleHiddenRow] = useState(state?.monthName === row.monthName);

  const locationSelectValue = selectAppLocationSelectValue();

  const isSelectedAllFacility = locationSelectValue.id === 'all';

  const { data: customerInfoData } = useCustomerInfoQuery({
    customerId,
    locationIds:
      locationSelectValue.level_name === 'allFacilities' ? undefined : locationSelectValue?.filterIds,
  });

  return (
    <>
      <tr key={uuidv4()} className={style.bodyRow}>
        <td className={style.dateColumn}>{row.monthName}</td>
        {customerInfoData?.showUnplannedDowntime && <td>{row.downtimeAvoided}</td>}
        <td>
          {isSelectedAllFacility
            ? row.equipmentLaborSavingsCustomerCurrency
            : row.equipmentLaborSavingsFacilityCurrency}
        </td>
        {customerInfoData?.showTotalCostSavings && (
          <td>{isSelectedAllFacility ? row.costAvoidedCustomerCurrency : row.costAvoidedFacilityCurrency}</td>
        )}
        {customerInfoData?.showCompletionReports && <td>{row.reportsCount}</td>}
        <td className={style.iconColumn} onClick={() => setVisibleHiddenRow((prev) => !prev)}>
          <ExpandRowIcon
            className={cx(style.expandRowIcon, { [style.expandRowIconTop]: isVisibleHiddenRow })}
          />
        </td>
      </tr>
      {isVisibleHiddenRow && (
        <tr key={uuidv4()}>
          <ActionItemsByMonthTable
            monthName={row.monthName}
            total={row.reportsCount}
            isVisibleHiddenRow={isVisibleHiddenRow}
          />
        </tr>
      )}
    </>
  );
};

export default ExpandedRow;
